import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import Typography from '@/components/atoms/typography';
import useDisclosure from '@/hooks/useDisclosure';
import useScrollBlock from '@/hooks/useScrollBlock';
import { AccountButtonProps } from '../types';
import MenuItem from '@/components/atoms/menu-item';
import Menu from '@/components/atoms/menu';
import { useParams, useRouter } from 'next/navigation';
import ButtonElement from './button';
import Link from 'next/link';
import { sdk } from '@/sdk/CommercetoolsSDK';
import Modal from '../../modal';
import Button from '@/components/atoms/button';
import useSwrClearCache from '@/hooks/useSwrClearCache';


const AccountButton = ({
  name,
  onLogoutClick,
  setLoading,
}: AccountButtonProps) => {


  const { locale } = useParams();
  const { isOpen, onClose } = useDisclosure();
  const [showLoggedOutWarning, setShowLoggedOutWarning] = useState(false);
  const clearCache = useSwrClearCache()


  const handleLogoutClick = () => {
    setLoading(true);
    clearStorage();
    onLogoutClick();
    onClose();
  };

  const clearStorage = useCallback(() => {
    localStorage.removeItem('customerAccessToken');
    localStorage.removeItem('business-unit-postal-code');
    localStorage.removeItem('store');
    localStorage.removeItem('business-unit');
    localStorage.removeItem('locale');
    localStorage.removeItem('associatedBusinessUnitsCached');
    localStorage.removeItem('--postal-code');
    localStorage.removeItem('__sessionCreation');
  }, []);
  const { blockScroll } = useScrollBlock();

  useLayoutEffect(() => {
    const logoutUserAction = (e: any) => {
      const skipNavigation = e.detail.navigate === false;
      clearStorage();
      if (skipNavigation) {
        sdk.composableCommerce.account.logout().then(() => {
          setShowLoggedOutWarning(true);
        });
      } else {
        onLogoutClick();
      }
    };
    window.addEventListener('LOGOUT_USER', logoutUserAction);
    return () => {
      window.removeEventListener('LOGOUT_USER', logoutUserAction);
    }
  }, []);


  useEffect(() => {
    blockScroll(isOpen);
  }, [blockScroll, isOpen]);

  const DashBoardLinks = [

    {
      title: 'Profile Settings',
      link: `/${locale}/profile-settings`,
    },
    {
      title: 'Team Management',
      link: `/${locale}/team-management`,
    },
  ];

  const closeLoggedOutWarningModal = useCallback(() => {
    onLogoutClick();
  }, [locale]);


  return (
    <>
      <div className="">
        <Menu data={name} Element={ButtonElement} classnames={'absolute right-0 top-[43px]'}>
          <Link href={`/profile-settings`}>
            <MenuItem
              classnames="bg-[#F8F8F8] w-[164px] text-white mx-auto p-[10px] border-b border-[#EEEEEE] cursor-pointer"
            >
              <Typography className="text-left text-14 !font-[500] !leading-[19px] text-[#333333]">
                {'Profile Settings'}
              </Typography>
            </MenuItem>
          </Link>
          <MenuItem
            classnames="bg-[#F8F8F8] w-[164px] text-white mx-auto p-[10px] border-b border-[#EEEEEE] cursor-pointer"
            onClick={handleLogoutClick}
          >
            <Typography className="text-left text-14 !font-[500] !leading-[19px] text-[#333333]">
              {'Sign out'}
            </Typography>
          </MenuItem>
        </Menu>
        {showLoggedOutWarning && <div>
          <Modal
            className="flex flex-col items-center justify-center !p-10"
            isOpen={showLoggedOutWarning}
            onRequestClose={closeLoggedOutWarningModal}
            preventScroll={true}
            closeButton={false}
            size="sm"
            variant="default"
            centered={true}
          >
            <Typography className="mt-2 px-4 text-center text-16 !font-medium text-black">
              Your session has expired. Please login to continue.
            </Typography>
            <Button
              size="custom"
              variant="secondary"
              type="button"
              className="mt-10 w-[120px] !bg-[#2B2C39] !py-3 px-6 text-white cursor-pointer"
              onClick={closeLoggedOutWarningModal}
            >
              Login
            </Button>
          </Modal>
        </div>}
      </div>
    </>

  );
};
export default AccountButton;